import { configureStore } from "redux-starter-kit";
import feedFiltersReducer from "./ducks/feed-filters";
import feedSidebarReducer from "./ducks/feed-sidebar";

const store = configureStore({
    reducer: { feedFiltersReducer, feedSidebarReducer }
});

export default store;
